// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__daWXU","inputWrap":"styles_inputWrap__1ObLe","input":"styles_input__101wI"};